import { defineStore, storeToRefs } from 'pinia'
import { ref, shallowRef, computed, unref, reactive } from '@vue/composition-api'
import axios from 'crypto-fetch/axios.js'
import { useAuthStore } from '@ms/stores/auth.js'
import { updateUserInfo } from '@ms/api/user'
import { formatNumber } from '@ms/utils/format'
import usePhone from './phone'
import useWalletStore from './wallet'

const KEY_NICKNAME = 'm_nickname'

export const useUserStore = defineStore('user', () => {
  const storePhone = usePhone()
  const { wallet, updateBalance, getBalance } = useWalletStore()

  const settings = reactive({
    visibleBalance: true
  })

  // 格式化过的用户余额，用来展示
  const showBalance = computed(() => {
    if (!settings.visibleBalance) return '******'
    const { balance } = wallet
    if (balance === '') return '--'
    else if (balance === 0) return '0'
    return formatNumber(balance, 2)
  })

  const toggleHideBalance = () => {
    settings.visibleBalance = !settings.visibleBalance
  }

  const { loginStatus } = storeToRefs(useAuthStore())

  const { safePhone } = storePhone

  const nickname = ref(localStorage.getItem(KEY_NICKNAME) || '')
  const showNickname = computed(() => {
    if (!loginStatus.value) return ''
    return nickname.value || unref(safePhone)
  })
  const setNickname = (val = '') => {
    nickname.value = val
    localStorage.setItem(KEY_NICKNAME, val || '')
  }

  const email = ref('')
  const setEmail = (val = '') => {
    email.value = val
  }

  // 用户其他基础信息
  const accountInfo = shallowRef({})

  // 获取用户基础信息
  const getAccountInfo = async () => {
    const data = await axios.get('/patron/account/info')
    const { phone = '', nickname = '', email = '', ...rest } = data
    storePhone.setPhone(phone)
    setNickname(nickname)
    setEmail(email)
    accountInfo.value = rest
  }

  const getAccountInfoWrap = async () => {
    try {
      await getAccountInfo()
    } catch (error) {
      console.error(error)
    }
  }

  // 修改用户信息
  const updateAccountInfo = async (options = {}) => {
    const body = {}
    for (const key in options) {
      let val = options[key]
      if (val) {
        if (key === 'gender') {
          val = parseInt(val)
        }
        body[key] = val
      }
    }
    await updateUserInfo(body)
    accountInfo.value = { ...accountInfo.value, ...body }
  }

  // 批量更新
  const update = ({ phone = '', nickname = '', email = '', ...rest }) => {
    storePhone.setPhone(phone)
    setNickname(nickname)
    email && setEmail(email)
    if ('status' in rest) {
      accountInfo.value = Object.assign({}, accountInfo.value, rest)
    }
  }

  const reset = () => {
    setNickname()
    setEmail()
    accountInfo.value = {}
    updateBalance(0)
  }

  return {
    settings,
    wallet,
    showBalance,
    toggleHideBalance,
    updateBalance,
    getBalance,
    ...storePhone,
    nickname,
    showNickname,
    setNickname,
    email,
    setEmail,
    update,
    accountInfo,
    getAccountInfo,
    getAccountInfoWrap,
    updateAccountInfo,
    reset
  }
})
